module.exports = __webpack_public_path__ + "Flag-288.11952942070743046ec50f6a30ddc3b5.svg";